export const getNumberDeclension = (absNumber, arrAnswers) => {
  const value = absNumber < 0 ? Math.abs(absNumber) : absNumber;
  const [singular, littlePlural, bigPlural] = arrAnswers;
  let remainder = value % 100;
  if ([11, 12, 13].includes(remainder)) return bigPlural;
  remainder = value % 10;
  if (remainder === 1) return singular;
  if ([2, 3].includes(remainder)) return littlePlural;
  return bigPlural;
};
